import { Button } from "antd";
import React from "react";
import { strings } from "res";
import moment from "moment";

export const kabupatens = [
  { "value": "KAB. MUSI RAWAS UTARA", "label": "KAB. MUSI RAWAS UTARA" },
  { "value": "KAB. OGAN KOMERING ILIR", "label": "KAB. OGAN KOMERING ILIR" },
  { "value": "KAB. OGAN KOMERING ULU", "label": "KAB. OGAN KOMERING ULU" },
  { "value": "KAB. OGAN KOMERING ULU SELATAN", "label": "KAB. OGAN KOMERING ULU SELATAN" },
  { "value": "KAB. OGAN KOMERING ULU TIMUR", "label": "KAB. OGAN KOMERING ULU TIMUR" },
  { "value": "KAB. OGAN ILIR", "label": "KAB. OGAN ILIR" },
  { "value": "KAB. LAHAT", "label": "KAB. LAHAT" },
  { "value": "KOTA LUBUK LINGGAU", "label": "KOTA LUBUK LINGGAU" },
  { "value": "KAB. EMPAT LAWANG", "label": "KAB. EMPAT LAWANG" },
  { "value": "KOTA PAGAR ALAM", "label": "KOTA PAGAR ALAM" },
  { "value": "KOTA PALEMBANG", "label": "KOTA PALEMBANG" },
  { "value": "KOTA PRABUMULIH", "label": "KOTA PRABUMULIH" },
  { "value": "KAB. PENUKAL ABAB LEMATANG ILIR", "label": "KAB. PENUKAL ABAB LEMATANG ILIR" },
  { "value": "KAB. BANYUASIN", "label": "KAB. BANYUASIN" },
  { "value": "KAB. MUARA ENIM", "label": "KAB. MUARA ENIM" },
  { "value": "KAB. MUSI RAWAS", "label": "KAB. MUSI RAWAS" },
  { "value": "KAB. MUSI BANYUASIN", "label": "KAB. MUSI BANYUASIN" }
]
export const opds = [
  { "label": "DINAS PENDIDIKAN", "value": "DINAS PENDIDIKAN" },
  { "label": "DINAS KESEHATAN", "value": "DINAS KESEHATAN" },
  { "label": "DINAS PEKERJAAN UMUM DAN PENATAAN RUANG", "value": "DINAS PEKERJAAN UMUM DAN PENATAAN RUANG" },
  { "label": "DINAS PERHUBUNGAN", "value": "DINAS PERHUBUNGAN" },
  { "label": "DINAS SOSIAL", "value": "DINAS SOSIAL" },
  { "label": "DINAS PERTANIAN", "value": "DINAS PERTANIAN" },
  { "label": "DINAS KETAHANAN PANGAN", "value": "DINAS KETAHANAN PANGAN" },
  { "label": "DINAS LINGKUNGAN HIDUP", "value": "DINAS LINGKUNGAN HIDUP" },
  { "label": "DINAS PARIWISATA", "value": "DINAS PARIWISATA" },
  { "label": "DINAS PERDAGANGAN", "value": "DINAS PERDAGANGAN" },
  { "label": "DINAS PERINDUSTRIAN", "value": "DINAS PERINDUSTRIAN" },
  { "label": "DINAS KOMUNIKASI DAN INFORMATIKA", "value": "DINAS KOMUNIKASI DAN INFORMATIKA" },
  { "label": "DINAS KEPENDUDUKAN DAN PENCATATAN SIPIL", "value": "DINAS KEPENDUDUKAN DAN PENCATATAN SIPIL" },
  { "label": "DINAS PEMUDA DAN OLAHRAGA", "value": "DINAS PEMUDA DAN OLAHRAGA" },
  { "label": "DINAS PERPUSTAKAAN DAN KEARSIPAN", "value": "DINAS PERPUSTAKAAN DAN KEARSIPAN" },
  { "label": "DINAS PEMBERDAYAAN PEREMPUAN DAN PERLINDUNGAN ANAK", "value": "DINAS PEMBERDAYAAN PEREMPUAN DAN PERLINDUNGAN ANAK" },
  { "label": "DINAS PEMBERDAYAAN MASYARAKAT DAN DESA", "value": "DINAS PEMBERDAYAAN MASYARAKAT DAN DESA" },
  { "label": "DINAS KOPERASI DAN UMKM", "value": "DINAS KOPERASI DAN UMKM" },
  { "label": "BADAN PERENCANAAN PEMBANGUNAN DAERAH", "value": "BADAN PERENCANAAN PEMBANGUNAN DAERAH" },
  { "label": "BADAN PENGELOLAAN KEUANGAN DAERAH", "value": "BADAN PENGELOLAAN KEUANGAN DAERAH" },
  { "label": "BADAN KEPEGAWAIAN DAERAH", "value": "BADAN KEPEGAWAIAN DAERAH" },
  { "label": "BADAN PENGAWASAN PEMBANGUNAN DAERAH", "value": "BADAN PENGAWASAN PEMBANGUNAN DAERAH" },
  { "label": "BADAN PENDAPATAN DAERAH", "value": "BADAN PENDAPATAN DAERAH" },
  { "label": "SEKRETARIAT DAERAH", "value": "SEKRETARIAT DAERAH" },
  { "label": "SEKRETARIAT DPRD", "value": "SEKRETARIAT DPRD" },
  { "label": "INSPEKTORAT DAERAH", "value": "INSPEKTORAT DAERAH" },
  { "label": "LAINNYA", "value": "LAINNYA" },
]

export const sdgs = [
  { "label": "TANPA KEMISKINAN", "value": "TANPA KEMISKINAN" },
  { "label": "TANPA KELAPARAN", "value": "TANPA KELAPARAN" },
  { "label": "KEHIDUPAN SEHAT DAN SEJAHTERA", "value": "KEHIDUPAN SEHAT DAN SEJAHTERA" },
  { "label": "PENDIDIKAN BERKUALITAS", "value": "PENDIDIKAN BERKUALITAS" },
  { "label": "KESETARAAN GENDER", "value": "KESETARAAN GENDER" },
  { "label": "AIR BERSIH DAN SANITASI LAYAK", "value": "AIR BERSIH DAN SANITASI LAYAK" },
  { "label": "ENERGI BERSIH DAN TERJANGKAU", "value": "ENERGI BERSIH DAN TERJANGKAU" },
  { "label": "PEKERJAAN LAYAK DAN PERTUMBUHAN EKONOMI", "value": "PEKERJAAN LAYAK DAN PERTUMBUHAN EKONOMI" },
  { "label": "INDUSTRI, INOVASI, DAN INFRASTRUKTUR", "value": "INDUSTRI, INOVASI, DAN INFRASTRUKTUR" },
  { "label": "BERKURANGNYA KESENJANGAN", "value": "BERKURANGNYA KESENJANGAN" },
  { "label": "KOTA DAN PEMUKIMAN YANG BERKELANJUTAN", "value": "KOTA DAN PEMUKIMAN YANG BERKELANJUTAN" },
  { "label": "KONSUMSI DAN PRODUKSI YANG BERTANGGUNG JAWAB", "value": "KONSUMSI DAN PRODUKSI YANG BERTANGGUNG JAWAB" },
  { "label": "PENANGANAN PERUBAHAN IKLIM", "value": "PENANGANAN PERUBAHAN IKLIM" },
  { "label": "EKOSISTEM LAUTAN", "value": "EKOSISTEM LAUTAN" },
  { "label": "EKOSISTEM DARATAN", "value": "EKOSISTEM DARATAN" },
  { "label": "PERDAMAIAN, KEADILAN, DAN KELEMBAGAAN YANG TANGGUH", "value": "PERDAMAIAN, KEADILAN, DAN KELEMBAGAAN YANG TANGGUH" },
  { "label": "KEMITRAAN UNTUK MENCAPAI TUJUAN", "value": "KEMITRAAN UNTUK MENCAPAI TUJUAN" },
  { "label": "LAINNYA", "value": "LAINNYA" },
]

export const categories = [// Example color
  { "label": "BEROPERASI", "value": "BEROPERASI", "color": "#33FF57" },
  { "label": "PEMBUATAN AKUN", "value": "PEMBUATAN AKUN", "color": "#C70039" },
  { "label": "TIDAK AKTIF", "value": "TIDAK AKTIF", "color": "#808080" },
  { "label": "LAINNYA", "value": "LAINNYA", "color": "#808080" }
];

export const status_kdkmp = [
  { "label": "BELUM PENDAMPINGAN", "value": "BELUM PENDAMPINGAN" },
  { "label": "PEMBUATAN AKUN", "value": "PEMBUATAN AKUN" },
  { "label": "ADMINISTRASI SIMKOPDES", "value": "ADMINISTRASI SIMKOPDES" },
  { "label": "PERMOHONAN", "value": "PERMOHONAN" },
  { "label": "SURVEY BUMN", "value": "SURVEY BUMN" },
  { "label": "PENDANAAN", "value": "PENDANAAN" },
  { "label": "BEROPERASI", "value": "BEROPERASI" },
  { "label": "BELUM AKTIF", "value": "BELUM AKTIF" },
];

export const masalah_kdkmp = [
  { "label": "TIDAK BERMASALAH", "value": "TIDAK BERMASALAH" },
  { "label": "AKUN BERMASALAH", "value": "AKUN BERMASALAH" },
  { "label": "NIB", "value": "NIB" },
  { "label": "KBLI", "value": "KBLI" },
  { "label": "NPWP", "value": "NPWP" },
  { "label": "PENGURUS MENGUNDURKAN DIRI", "value": "PENGURUS MENGUNDURKAN DIRI" },
  { "label": "KEPALA DESA", "value": "KEPALA DESA" },
  { "label": "JARAK JAUH", "value": "JARAK JAUH" },
  { "label": "SYARAT BUMN SULIT", "value": "SYARAT BUMN SULIT" },
  { "label": "VERIFIKASI BUMN", "value": "VERIFIKASI BUMN" },
  { "label": "TIDAK ADA BA", "value": "TIDAK ADA BA" }
];

export const kolomKDKMP = [
  {
    title: "Id",
    dataIndex: "id",
    value: "id",
  },
  {
    title: "Name",
    dataIndex: "name",
    value: "name",
  },
  {
    title: "PMO",
    dataIndex: "id_pmo",
    value: "id_pmo",
  },
  {
    title: "BA",
    dataIndex: "id_ba",
    value: "id_ba",
  },
  {
    title: "Status KDKMP",
    dataIndex: "status",
    value: "status",
    render: (_, record) => {
      if (record.status === "BELUM PENDAMPINGAN") {
        return <div className="text-green text-center">
          <b style={{ color: "red", font: "bold" }}>BELUM PENDAMPINGAN</b>
        </div>
      }
      else if (record.status === "PEMBUATAN AKUN") {
        return <div className="text-green text-center">
          <b style={{ color: "orange", font: "bold" }}>PEMBUATAN AKUN</b>
        </div>
      }
      else if (record.status === "ADMINISTRASI SIMKOPDES") {
        return <div className="text-green text-center">
          <b style={{ color: "orange", font: "bold" }}>ADMINISTRASI SIMKOPDES</b>
        </div>
      }
      else if (record.status === "PERMOHONAN") {
        return <div className="text-green text-center">
          <b style={{ color: "blue", font: "bold" }}>PERMOHONAN</b>
        </div>
      }
      else if (record.status === "SURVEY BUMN") {
        return <div className="text-green text-center">
          <b style={{ color: "blue", font: "bold" }}>SURVEY BUMN</b>
        </div>
      }
      else if (record.status === "BEROPERASI") {
        return <div className="text-green text-center">
          <b style={{ color: "green", font: "bold" }}>BEROPERASI</b>
        </div>
      }
      else {
        return <div className="text-green text-center">
          <b style={{ color: "red", font: "bold" }}>BELUM AKTIF</b>
        </div>
      }
    },
  },
  {
    title: "Kabupaten",
    dataIndex: "kabupaten",
    value: "kabupaten",
  },
  {
    title: "Kecamatan",
    dataIndex: "kecamatan",
    value: "kecamatan",
  },
  {
    title: "AHU",
    dataIndex: "ahu",
    value: "ahu",
  },
  // {
  //   title: "PIC",
  //   dataIndex: "pic",
  //   value: "pic",
  //   render: (_, record) => (
  //     <div>
  //       <a target="_blank">{record.no_phone || "Belum Ada"}</a>
  //     </div>
  //   ),
  // },
  {
    title: "Tanggal Didirikan",
    dataIndex: "start_date",
    value: "start_date",
    render: (_, record) => (
      <div>
        {record.start_date}
      </div>
    ),
  }
];

export const kolomKDKMPBA = [
    {
      title: "Id",
      dataIndex: "id",
      value: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      value: "name",
    }, 
    {
      title: "PMO",
      dataIndex: "id_pmo",
      value: "id_pmo",
    },
    {
      title: "BA",
      dataIndex: "id_ba",
      value: "id_ba",
    },
    {
      title: "Status KDKMP",
      dataIndex: "status",
      value: "status",
      render: (_, record) => {
        if (record.status === "BELUM PENDAMPINGAN") {
          return <div className="text-green text-center">
            <b style={{ color: "red", font: "bold" }}>BELUM PENDAMPINGAN</b>
          </div>
        }
        else if (record.status === "PEMBUATAN AKUN") {
          return <div className="text-green text-center">
            <b style={{ color: "orange", font: "bold" }}>PEMBUATAN AKUN</b>
          </div>
        }
        else if (record.status === "ADMINISTRASI SIMKOPDES") {
          return <div className="text-green text-center">
            <b style={{ color: "orange", font: "bold" }}>ADMINISTRASI SIMKOPDES</b>
          </div>
        }
        else if (record.status === "PERMOHONAN") {
          return <div className="text-green text-center">
            <b style={{ color: "blue", font: "bold" }}>PERMOHONAN</b>
          </div>
        }
        else if (record.status === "SURVEY BUMN") {
          return <div className="text-green text-center">
            <b style={{ color: "blue", font: "bold" }}>SURVEY BUMN</b>
          </div>
        }
         else if (record.status === "BEROPERASI") {
          return <div className="text-green text-center">
            <b style={{ color: "green", font: "bold" }}>BEROPERASI</b>
          </div>
        }
        else {
          return <div className="text-green text-center">
            <b style={{ color: "red", font: "bold" }}>BELUM AKTIF</b>
          </div>
        }
      },
    },
    {
      title: "Bermasalah",
      dataIndex: "status",
      value: "status",
      render: (_, record) => {
        if (record.status === "TIDAK BERMASALAH") {
          return <div className="text-green text-center">
            <b style={{ color: "red", font: "bold" }}>TIDAK BERMASALAH</b>
          </div>
        }
        else if (record.status === "NIB") {
          return <div className="text-green text-center">
            <b style={{ color: "red", font: "bold" }}>NIB</b>
          </div>
        }
        else if (record.status === "AKUN SIMKOPDES") {
          return <div className="text-green text-center">
            <b style={{ color: "red", font: "bold" }}>AKUN SIMKOPDES</b>
          </div>
        }
        else if (record.status === "PERMOHONAN") {
          return <div className="text-green text-center">
            <b style={{ color: "red", font: "bold" }}>PERMOHONAN</b>
          </div>
        }
        else if (record.status === "SURVEY BUMN") {
          return <div className="text-green text-center">
            <b style={{ color: "red", font: "bold" }}>SURVEY BUMN</b>
          </div>
        }
         else if (record.status === "BEROPERASI") {
          return <div className="text-green text-center">
            <b style={{ color: "red", font: "bold" }}>BEROPERASI</b>
          </div>
        }
        else {
          return <div className="text-green text-center">
            <b style={{ color: "red", font: "bold" }}>BELUM AKTIF</b>
          </div>
        }
      },
    },
    {
      title: "Kabupaten",
      dataIndex: "kabupaten",
      value: "kabupaten",
    },
     {
      title: "Kecamatan",
      dataIndex: "kecamatan",
      value: "kecamatan",
    },
    {
      title: "AHU",
      dataIndex: "ahu",
      value: "ahu",
    }
  ];

export const kolomLaporanBa = [
  {
    title: "Id",
    dataIndex: "id",
    value: "id",
  },
  {
    title: "Name",
    dataIndex: "name",
    value: "name",
  },
  {
    title: "Status Laporan",
    dataIndex: "status",
    value: "status",
    render: (_, record) => {
      if (record.status === "BELUM PENDAMPINGAN") {
        return <div className="text-green text-center">
          <b style={{ color: "red", font: "bold" }}>BELUM PENDAMPINGAN</b>
        </div>
      }
      else if (record.status === "PEMBUATAN AKUN") {
        return <div className="text-green text-center">
          <b style={{ color: "orange", font: "bold" }}>PEMBUATAN AKUN</b>
        </div>
      }
      else if (record.status === "ADMINISTRASI SIMKOPDES") {
        return <div className="text-green text-center">
          <b style={{ color: "orange", font: "bold" }}>ADMINISTRASI SIMKOPDES</b>
        </div>
      }
      else if (record.status === "PERMOHONAN") {
        return <div className="text-green text-center">
          <b style={{ color: "blue", font: "bold" }}>PERMOHONAN</b>
        </div>
      }
      else if (record.status === "SURVEY BUMN") {
        return <div className="text-green text-center">
          <b style={{ color: "blue", font: "bold" }}>SURVEY BUMN</b>
        </div>
      }
      else if (record.status === "BEROPERASI") {
        return <div className="text-green text-center">
          <b style={{ color: "green", font: "bold" }}>BEROPERASI</b>
        </div>
      }
      else {
        return <div className="text-green text-center">
          <b style={{ color: "red", font: "bold" }}>BELUM AKTIF</b>
        </div>
      }
    },
  },
  {
    title: "Kabupaten",
    dataIndex: "kabupaten",
    value: "kabupaten",
  },
  {
    title: "Tanggal Dikumpulkan",
    dataIndex: "start_date",
    value: "start_date",
    render: (_, record) => (
      <div>
        {record.start_date}
      </div>
    ),
  }
];

export const kolomLaporanPMO = [
  {
    title: "Id",
    dataIndex: "id",
    value: "id",
  },
  {
    title: "Name",
    dataIndex: "name",
    value: "name",
  },
  {
    title: "Status Laporan",
    dataIndex: "status",
    value: "status",
    render: (_, record) => {
      if (record.status === "BELUM PENDAMPINGAN") {
        return <div className="text-green text-center">
          <b style={{ color: "red", font: "bold" }}>BELUM PENDAMPINGAN</b>
        </div>
      }
      else if (record.status === "PEMBUATAN AKUN") {
        return <div className="text-green text-center">
          <b style={{ color: "orange", font: "bold" }}>PEMBUATAN AKUN</b>
        </div>
      }
      else if (record.status === "ADMINISTRASI SIMKOPDES") {
        return <div className="text-green text-center">
          <b style={{ color: "orange", font: "bold" }}>ADMINISTRASI SIMKOPDES</b>
        </div>
      }
      else if (record.status === "PERMOHONAN") {
        return <div className="text-green text-center">
          <b style={{ color: "blue", font: "bold" }}>PERMOHONAN</b>
        </div>
      }
      else if (record.status === "SURVEY BUMN") {
        return <div className="text-green text-center">
          <b style={{ color: "blue", font: "bold" }}>SURVEY BUMN</b>
        </div>
      }
      else if (record.status === "BEROPERASI") {
        return <div className="text-green text-center">
          <b style={{ color: "green", font: "bold" }}>BEROPERASI</b>
        </div>
      }
      else {
        return <div className="text-green text-center">
          <b style={{ color: "red", font: "bold" }}>BELUM AKTIF</b>
        </div>
      }
    },
  },
  {
    title: "Kabupaten",
    dataIndex: "kabupaten",
    value: "kabupaten",
  },
  {
    title: "Tanggal Dikumpulkan",
    dataIndex: "start_date",
    value: "start_date",
    render: (_, record) => (
      <div>
        {record.start_date}
      </div>
    ),
  }
];
